<app-aot-section></app-aot-section>
<app-about-me-section id="about-me"></app-about-me-section>
<app-skill-section id="skill"></app-skill-section>
<app-my-projects-section id="projects"></app-my-projects-section>
<app-contact-section id="contact"></app-contact-section>
